"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PromptWindow;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _PromptWindowModule = _interopRequireDefault(require("./PromptWindow.module.scss"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

var _PromptWindow = _interopRequireDefault(require("./PromptWindow.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-array-index-key */
function PromptWindow(_ref) {
  var children = _ref.children,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_PromptWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _PromptWindowModule.default.title
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _PromptWindowModule.default.dragHandler,
    hasCloseBtn: false
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _PromptWindowModule.default.body
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _PromptWindowModule.default.text
  }, children), (onSubmit || onCancel) && /*#__PURE__*/_react.default.createElement("div", {
    className: _PromptWindowModule.default.buttons
  }, onSubmit && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.MSG,
    onClick: onSubmit
  }, formatMessage(_PromptWindow.default.ok)), onCancel && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.MSG,
    onClick: onCancel
  }, formatMessage(_PromptWindow.default.cancel)))), /*#__PURE__*/_react.default.createElement("div", {
    className: _PromptWindowModule.default.bottom
  }));
}